import { CASE_STATUS } from '../store/NewPatient/utils';

export const retainer_statusList = {
    SUBMITTED: [
        {
            value: 'AWAITING',
            label: 'Awaiting More Records{Remark: ?}',
        },
        {
            value: 'PRODUCTION',
            label: '{Remark: ?} Production In Progress',
        },
    ],
    AWAITING: [
        {
            value: 'PRODUCTION',
            label: '{Remark: ?} Production In Progress',
        },
    ],
    PRODUCTION: [
        {
            value: 'DELIVERED',
            label: 'Retainer dispatched to our distributor ',
        },
    ],
    DELIVERED: [
        {
            value: 'ALL_DELIVERED',
            label: 'All {Remark: ?} Delivered',
        },
    ],
    ALL_DELIVERED: [
        {
            value: 'none',
            label: 'Treatment End',
        },
    ],
    ENDED: [
        {
            value: 'none',
            label: 'This case has ended by the doctor',
        },
    ],
};
export const statusList = {
    SUBMITTED: [
        {
            value: 'AWAITING',
            label: 'Awaiting More Records{Remark: ?}',
        },
        {
            value: 'RECEIVED',
            label: 'Confirmed All Materials Received',
        },
    ],
    DEFECT_RESPONDED: [
        {
            value: 'RECEIVED',
            label: 'Confirmed All Materials Received',
        },
    ],
    AWAITING: [
        {
            value: 'AWAITING',
            label: 'Awaiting More Records{Remark: ?}',
        },
        {
            value: 'RECEIVED',
            label: 'Confirmed All Materials Received',
        },
    ],
    RECEIVED: [
        {
            value: 'none',
            label: 'Wait For Uploading Treatment Plan',
        },
    ],
    PLAN_UPLOADED: [
        {
            value: 'CHANGE_REQUEST',
            label: 'Treatment Plan Change Request Received',
        },
    ],
    CHANGE_REQUEST: [
        {
            value: 'none',
            label: 'Wait For Uploading Treatment Plan',
        },
        {
            value: 'AWAITING',
            label: 'Awaiting More Records{Remark: ?}',
        },
        {
            value: 'RECEIVED',
            label: 'Confirmed All Materials Received',
        },
    ],
    PLAN_APPROVED: [
        {
            value: 'PRODUCTION',
            label: 'Production In Progress',
        },
    ],
    PRODUCTION: [
        {
            value: 'DELIVERED',
            label: 'Aligners Set {No.1 ?}-{No.2 ?} Delivered',
            selfDesign: false,
        },
        {
            value: 'DELIVERED',
            label: 'Aligners Batch {No.1 ?} Delivered',
            selfDesign: true,
        },
    ],
    DELIVERED: [
        {
            value: 'none',
            label: 'Awaiting Doctors for Requesting Next Set',
        },
        {
            value: 'ALL_DELIVERED',
            label: 'All Aligners Sets Are Delivered',
        },
    ],
    NEXT_SET_REQUEST: [
        {
            value: 'PRODUCTION',
            label: 'Production In Progress',
        },
    ],
    ALL_DELIVERED: [
        {
            value: 'none',
            label: 'Await For Refinement / Retainer If Needed',
        },
    ],
    ENDED: [
        {
            value: 'none',
            label: 'This case has ended by the doctor',
        },
    ],
    REFINEMENT: [
        {
            value: 'AWAITING',
            label: 'Awaiting More Records{Remark: ?}',
        },
        {
            value: 'RECEIVED',
            label: 'Confirmed All Materials Received',
        },
    ],
    DEFECT_UPLOADED: [
        {
            value: 'DEFECT_UPLOADED',
            label: '{No.2 ?} Defective Impression / Data Detected {No.1 ?} on {Remark: ?} - Complete',
        },
    ],
    DEFECT_RESUBMIT: [
        {
            value: 'AWAITING',
            label: 'Awaiting More Records{Remark: ?}',
        },

        {
            value: 'RECEIVED',
            label: 'Confirmed All Materials Received',
        },
    ],
    // RETRACK:[
    //   {
    //     value: "RETRACK_END",
    //     label: "ReTrack {Status}"
    //   },
    // ],
    RETRACK: [
        {
            value: 'RETRACK_AWAITING',
            label: 'ReTrack Awaiting More Records{Remark: ?}',
        },
        {
            value: 'RETRACK_ALL_MATERIAL_RECEIVED',
            label: 'ReTrack Confirmed All Materials Received',
        },
    ],
    RETRACK_AWAITING: [
        {
            value: 'RETRACK_AWAITING',
            label: 'ReTrack Awaiting More Records{Remark: ?}',
        },
        {
            value: 'RETRACK_ALL_MATERIAL_RECEIVED',
            label: 'ReTrack Confirmed All Materials Received',
        },
    ],
    RETRACK_ALL_MATERIAL_RECEIVED: [
        {
            value: 'RETRACK_REPORT',
            label: 'ReTrack REPORT',
        },
        {
            value: 'RETRACK_END',
            label: 'ReTrack Unsuccessful',
        },
    ],
    RETRACK_REPORT: [
        {
            value: 'RETRACK_PRODUCTION_IN_PROGRESS',
            label: 'ReTrack: Production In Progress',
        },
        {
            value: 'DELIVERED',
            label: 'Aligners Set {No.1 ?}-{No.2 ?} Delivered',
        },
        {
            value: 'ALL_DELIVERED',
            label: 'All Aligners Sets Are Delivered',
        },
    ],

    // RETRACK_CONTINUE:[
    //   {
    //     value: "RETRACK_PRODUCTION_IN_PROGRESS",
    //     label: "ReTrack: Production In Progress",
    //   }
    // ],

    RETRACK_PRODUCTION_IN_PROGRESS: [
        {
            value: 'DELIVERED',
            label: 'ReTrack Delivered and Delivered',
        },
    ],
    RETRACK_END: [
        {
            value: 'none',
            label: 'Awaiting Doctors for Requesting Next Set',
        },
        // {
        //   value: "ALL_DELIVERED",
        //   label: "All Aligners Sets Are Delivered"
        // },
        // {
        //   value: "RETRACK_CONTINUE",
        //   label:'ReTrack Continue'
        // }
    ],
    UPGRADE_REQUEST: [
        {
            value: 'AWAITING',
            label: 'Awaiting More Records{Remark: ?}',
        },
        {
            value: 'RECEIVED',
            label: 'Confirmed All Materials Received',
        },
    ],
};
// Flag to hide the modify panel in the simulation
export const getIsHideModifyPanel = (caseStatus = '', tpApprovedFlag = false) => {
    return caseStatus !== 'PLAN_UPLOADED' || tpApprovedFlag;
};

export const CASE_STATUS_ALLOW_UPLOAD_SUPPORTING_IMGS = [
    CASE_STATUS.AWAITING,
    CASE_STATUS.RECEIVED,
    CASE_STATUS.RETRACK_AWAITING,
    CASE_STATUS.RETRACK_ALL_MATERIAL_RECEIVED,
];
